window.addEventListener('load', () => {
    Array.from(document.querySelectorAll('a[href^="http"]'))
        .filter(a => {
            return a.hostname !== window.location.hostname;
        })
        .forEach(a => {
            a.target = '_blank';
            a.rel = 'noreferrer';
        });
});